module.exports = __webpack_public_path__ + "images/btn-socialsign-tw.png?2be8e";